import styled, { css } from 'styled-components'

export const ProductsContainer = styled.div`
  width: 100%;
  margin: 0;
  > svg {
    color: ${props => props.theme.colors.headingColor};
    font-size: 24px;
    cursor: pointer;
    margin-bottom: 5px;
    margin-left: 20px;
    ${props => props.theme.rtl && css`
      margin-right: 20px;
      margin-left: 0;
    `}
  }
  > div {
    background-color: ${(props) => props.theme?.colors?.backgroundPage};
  }

`

export const ProductLoading = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const SkeletonItem = styled.div`
  width: 80%;
  margin: 30px auto;

  span {
    margin-bottom: 10px;
  }
`
export const MobileCartViewWrapper = styled.div`
  position: fixed;
  width: 92vw;
  left: 4vw;
  bottom: 15px;
  background-color: #000;
  border: 2px solid #fbff00;
  padding: 15px 15px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  z-index: 1006;
  box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.8);
  border-radius: 10px;

  .cart-info-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 12px;
  }

  .cart-details {
    display: flex;
    flex-direction: column;
    color: #FFF;
  }

  .cart-label {
    font-weight: 800;
    font-size: 1.1rem;
    text-transform: uppercase;
  }

  .cart-price {
    font-weight: 900;
    font-size: 1.4rem;
    margin-top: 2px;
  }

  .action-btns {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .plus-icon {
    width: 32px;
    height: 32px;
    background: transparent;
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    font-weight: bold;
    border: 1.5px solid #fbff00;
  }

  .view-cart-btn {
    background: #ff007c !important;
    color: #fff !important;
    border: none;
    font-weight: 800;
    padding: 0 15px;
    height: 48px;
    border-radius: 25px;
    font-size: 0.95rem;
    white-space: nowrap;
  }

  .checkout-btn {
    background: #0061ff !important;
    color: #fff !important;
    border: none;
    font-weight: 900;
    width: 100%;
    padding: 12px;
    border-radius: 25px;
    text-transform: uppercase;
    font-size: 1rem;
    letter-spacing: 0.5px;
  }
`

export const BusinessCartContent = styled.div`
  background: #02e5ff;
  color: #FFF;
  border: 1px solid #333;
  padding: 30px;
  position: relative;
  margin-bottom: 30px;
  max-height: ${({ maxHeight }) => `${maxHeight}px`};
  overflow: auto;

  .product.accordion {
    margin: 0;
  }

  /* .accordion.active {
    padding-bottom: 10px;
  } */

  ${({ isModal }) => !isModal && css`
    border: 1px solid #E9ECEF;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
    border-radius: 7.6px;
  `}

  @media (min-width: 1200px) {
    position: sticky;
    top: 0;
  }

  @media (min-width: 768px) {
    padding: 35px 30px;
  }
`

export const EmptyCart = styled.div`
  .empty-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    svg {
      font-size: 45px;
      color: #B1BCCC;
      margin-top: 10px;
    }

    p {
      font-size: 14px;
      color: #B1BCCC;
      margin: 23px 0 0 0;
    }
  }
`
export const Title = styled.h1`
  font-weight: 600;
  font-size: 20px;
  color: #FFF;
  margin-bottom: 18px;
`
export const EmptyBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;

  span {
    font-weight: 600;
    font-size: 16px;
    color: ${props => props.theme.colors.darkTextColor};
  }

  button {
    color: #748194;
    background: #F8F9FA;
    border: 1px solid #F8F9FA;
    border-radius: 7.6px;
    height: 44px;
    font-size: 14px;
    padding-left: 25px;
    padding-right: 25px;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  ${props => props.switchFlex && css`
    flex-direction: column;
    align-items: flex-start;
  `}

  .back-arrow {
    font-size: 24px;
    cursor: pointer;
  }
  .fixed-arrow {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10001;
    width: 100vw;
    background-color: ${props => props.theme.colors.backgroundPage};
    height: 56px;
    display: flex;
    align-items: center;

    ${props => props.theme?.rtl
    ? css`padding-right: 10px;`
    : css`padding-left: 10px;`}

    @media (min-width: 993px){
      width: 100px;
      ${({ useFullWidth }) => useFullWidth && css`
        width: 100vw;
      `}
    }
  }
  .fixed-arrow-width{
    width: 100vw;
  }
`
export const OrderContextUIWrapper = styled.div`
  flex: 1;
  width: 100%;
  ${props => props.theme.rtl && css`
    margin-left: 0px;
    margin-right: 15px;
  `}
`

export const SpinnerCart = styled.div`
  position: absolute;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
